import React from 'react'
import extractAppleMusicEmbedUrl from '../../ui/SongPreview/util/extractAppleMusicEmbedUrl'

const AppleMusicEmbeddedPlaylistPreview = ({ url }) => {
  if(!url) {
    return null
  }

  const appleMusicEmbedUrl = extractAppleMusicEmbedUrl(url)
  if(!appleMusicEmbedUrl) {
    return (
      <div>
        <p>Unable to load playlist. Please check the URL.</p>
      </div>
    )
  }

  return (
    <iframe
      style={{ borderRadius: 12 }}
      src={appleMusicEmbedUrl}
      width="100%"
      height="450"
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    ></iframe>
  )
}

export default AppleMusicEmbeddedPlaylistPreview
